import React from 'react';
import { motion } from 'framer-motion';
import { Scale, AlertCircle, TrendingDown } from 'lucide-react';
export function CostTable() {
  const rows = [{
    without: 'Madrugadas improvisando sin sistema',
    cost: 'Agotamiento que se acumula semana a semana'
  }, {
    without: 'Regresiones sin protocolo',
    cost: 'Semanas de retroceso innecesario'
  }, {
    without: 'Sin diferenciación entre tipos de despertar',
    cost: 'Reforzando dependencias sin saberlo'
  }, {
    without: 'Bebé prematuro con tablas incorrectas',
    cost: 'Expectativas que generan más angustia'
  }, {
    without: 'Buscando en Google a las 3 AM',
    cost: 'El mismo ciclo la próxima semana'
  }];
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-57">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} data-id="element-58">
        <div className="text-center mb-10" data-id="element-59">
          <div className="inline-flex items-center justify-center p-3 bg-navy-800 rounded-full mb-4 border border-navy-600" data-id="element-60">
            <Scale className="w-8 h-8 text-gold-400" data-id="element-61" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-62">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <div className="overflow-hidden rounded-2xl border border-red-900/30 bg-navy-900/80 shadow-2xl" data-id="element-63">
          <table className="w-full text-left border-collapse" data-id="element-64">
            <thead data-id="element-65">
              <tr data-id="element-66">
                <th className="p-4 md:p-6 border-b border-navy-700 bg-navy-800 text-gray-300 font-semibold w-1/2" data-id="element-67">
                  <div className="flex items-center gap-2" data-id="element-68">
                    <AlertCircle className="w-4 h-4 text-gray-400" data-id="element-69" />
                    Sin el Kit SOS Nocturno
                  </div>
                </th>
                <th className="p-4 md:p-6 border-b border-red-900/50 bg-red-950/20 text-red-300 font-bold w-1/2" data-id="element-70">
                  <div className="flex items-center gap-2" data-id="element-71">
                    <TrendingDown className="w-4 h-4 text-red-400" data-id="element-72" />
                    El costo real
                  </div>
                </th>
              </tr>
            </thead>
            <tbody data-id="element-73">
              {rows.map((row, index) => <tr key={index} className="border-b border-navy-800 last:border-0" data-id="element-74">
                  <td className="p-4 md:p-6 text-blue-100/70" data-id="element-75">{row.without}</td>
                  <td className="p-4 md:p-6 text-red-200/90 font-medium bg-red-950/10" data-id="element-76">
                    {row.cost}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </motion.div>
    </section>;
}